/**
 * This file holds computed state properties
 * Please refer to https://vuex.vuejs.org/guide/getters.html for more information
 */

const getters = {
  minimumDimensions(store, getters, rootState) {
    return pdmModel => {
      try {
        return store.pdm[pdmModel].components[Object.keys(store.pdm[pdmModel].components).find(c => store.pdm[pdmModel].components[c].ugc)].ugc.image_requirements.minimum_dimensions;
      } catch (error) {
        console.warm('Unable to find UGC minimum_dimensions for ', pdmModel, '. Falling back to default 800x1000.');
        return [800, 1000];
      }
    }
  },
  /**
   * @function loadAutomatically
   * Checks the web address for the parameter that
   * signals that the UGC Entry Point modal should open by itself
   * after the page and dependencies have loaded.
   * The parameter will be added on the inbound link of the marketing collateral.
   * For example, a Tweet will contain https://www.vans.com/ugc-entry-point.html?loadUGC=true
   * @returns {Boolean} True to indicate the modal should open as soon as possible.
   */
  loadAutomatically(store, getters, rootState) {
    return rootState.utils.queryParams.loadUGC === "true" || rootState.utils.queryParams.canvas;
  },

  /**
   * @function loadUGCFlow
   * Checks the web address for the parameter that
   * signals that the UGC Entry Point modal should open by itself
   * after the page and dependencies have loaded.
   * The parameter will be added on the inbound link of the marketing collateral.
   * For example, a Tweet will contain https://www.vans.com/ugc-entry-point.html?loadUGC=true&ugc-flow=slip-on-only
   * @returns {String} CTA id name indicate the button id will should open as soon as possible.
   */
  loadUGCFlow(store, getters, rootState) {
    return rootState.utils.queryParams.ugcFlow;
  },
  /**
  * @function getUGCUrl
  * @returns {String} Returns url to request ugc image according if ugcImage and ugcImageType are defined or not
  */
  getUGCUrl(store, getters, rootState) {
    const { secondaryImage: { active, id, type }, uploadedImageId, uploadedImageType } = store;
    let ugcImage = uploadedImageId;
    let ugcImageType = uploadedImageType;

    if (active && id && type) {
      ugcImage = id;
      ugcImageType = type;
    }

    return ugcImage && ugcImageType ?
     `${ rootState.endPoints.ugcentrypoint.ugcImageBucket }/ugc_images/${ ugcImage }.${ ugcImageType }` :
     null;
  },
  /* @function getUGCImageId
  * @returns {String} Returns id of the request ugc image
  */
  getUGCImageId(store, getters, rootState) {
    const { uploadedImageId } = store;
    return uploadedImageId;
  },
  getNumberOfModels(store) {
    return store.orderStyles.length;
  },
  getImageStatus(state, rootState) {
    return state.imageStatus;
  }
};

export default getters;
